<template>
    <div class="Engagements">
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Select Referral:</label>
                    <select class="form-control" v-model="SelectedReferralID" @change="OnReferralSelectChange">
                        <!--<option value="NEW">CREATE NEW INQUIRY</option>-->
                        <option v-for="referral in CommunityFamilyReferrals" :value="referral.Id">{{referral.ProfileLabel}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row" v-if="SelectedReferralID != 'NEW'">
            <div class="col">
                <ReferralRecord :list-data="SelectedReferral" />
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import ReferralRecord from '../../Referrals/ReferralRecord/ReferralRecord.vue';
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                SelectedReferralID: "",
                CommunityFamilyReferrals: []
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            GetReferrals() {
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/Referrals", { CommunityFamilyID: this.RecordData.Id }, this.GetReferralsSuccess, () => { }, true);
            },
            GetReferralsSuccess(response) {
                if (response.data.data.length > 0) {
                    this.CommunityFamilyReferrals = response.data.data;
                    this.SelectedReferralID = response.data.data[0].Id;
                }
                
                
            },
            //NEW INQUIRY
            OnReferralSelectChange() {
                if (this.SelectedReferralID == "NEW") {
                    alert("new inquiry requested");
                }
                console.log("change fired");
            }
        },
        components: {
            ReferralRecord
        },
        mounted() {
            this.GetReferrals();
        },
        computed: {
            SelectedReferral: function () {
                if (this.SelectedReferralID != "NEW") {
                    let targetId = this.SelectedReferralID;
                    let targetReferral = this.CommunityFamilyReferrals.filter(f => f.Id == targetId);
                    if (targetReferral.length > 0) {
                        return targetReferral[0];
                    } else {
                        return {};
                    }
                } else {
                    return {};
                }
                
            }
        }
    }
</script>

<style scoped>
</style>